var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex space-x-3 md:space-x-5 pl-5 md:pl-10 py-5 sticky bg-white -top-0 md:-top-6"
  }, _vm._l([['Non observable', 'bg-gray-600'], ['Non acquis', 'bg-pink-600'], ['En apprentissage', 'bg-indigo-300'], ['En évolution', 'bg-indigo-600'], ['Acquis', 'bg-teal-600']], function (legend) {
    return _c('div', {
      key: legend[0],
      staticClass: "flex flex-row space-x-1 md:space-x-2 h-3 md:h-5 justify-start md:items-center"
    }, [_c('div', {
      staticClass: "h-3 w-3 md:h-5 md:w-5 rounded-full",
      class: legend[1]
    }), _vm._v(" "), _c('div', {
      staticClass: "text-sm"
    }, [_vm._v("\n      " + _vm._s(legend[0]) + "\n    ")])]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }